import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { Icon } from '@ui-kitten/components';

import Button from '../../../../Components/Button';
import themeColor from '../../../../Theme/colors';

export enum LeftRight {
  LEFT = 'left',
  RIGHT = 'right',
}

type Props = {
  position: LeftRight;
  [key: string]: any;
};

const btnSize = 30;
const Arrow = ({ position, ...rest }: Props) => {
  const posStyle = useMemo(() => {
    if (position === LeftRight.LEFT) return { left: -(btnSize / 2) };
    else if (position === LeftRight.RIGHT) return { right: -(btnSize / 2) };
    return {};
  }, [position]);
  return (
    <View style={[styles.wrapper, posStyle]}>
      <Button
        {...rest}
        hitSlop={10}
        status="info"
        style={[rest.style, styles.btn]}
      >
        {() => (
          <Icon
            name={`chevron-${position}`}
            fill={themeColor.white}
            style={styles.icon}
          />
        )}
      </Button>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    justifyContent: 'center',
    position: 'absolute',
    bottom: 0,
    top: 0,
    zIndex: 1,
  },
  btn: {
    borderRadius: 20,
    opacity: 0.8,
    height: btnSize,
    width: btnSize,
    minWidth: 0,
    minHeight: 0,
  },
  icon: {
    height: btnSize - 5,
    width: btnSize - 5,
  },
});

export default Arrow;
